import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';
import React from 'react';

import './HistoricalPercentageChangeWidgetSettings.scss';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor.tsx';
import { useSelectAppSettings } from 'app/store/appSettings/selectors.ts';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher.ts';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors.ts';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor.tsx';
import WidgetSettingsNumericValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsNumericValueEditor.tsx';

export const HistoricalPercentageChangeWidgetSettingsTitle =
    'Historical % Change Widget Settings';

export function HistoricalPercentageChangeWidgetSettings({
    config,
    onConfigChanged,
}: {
    config: HistoricalPercentageChangeConfig;
    onConfigChanged: (delta: Partial<HistoricalPercentageChangeConfig>) => void;
}) {
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    return (
        <div className="HistoricalPercentageChangeWidgetSettings">
            <div className="group">
                <div className="period-qty">
                    <WidgetSettingsNumericValueEditor
                        propertyName={'periodQty'}
                        config={config}
                        min={1}
                        onChange={onConfigChanged}
                        label={'Trading Days'}
                    />
                </div>

                <div className="average-volume">
                    <WidgetSettingsCheckboxValueEditor
                        propertyName={'hideAverageVolume'}
                        config={config}
                        inverted={true}
                        label={'Average Volume'}
                        onChange={onConfigChanged}
                    />
                </div>
            </div>

            {isAppModeNewportSingleWidget && (
                <AppSettingsEditor
                    appSettings={appSettings}
                    onAppSettingsChanged={dispatchUpdateAppSettings}
                    specifyVisibleControls={{
                        currency: true,
                        symbology: true,
                        combineSellsAndShorts: true,
                        showChartHelp: true,
                    }}
                />
            )}
        </div>
    );
}
